import { render } from "./ThemeSwitchView.vue?vue&type=template&id=1cdc7153&scoped=true"
import script from "./ThemeSwitchView.vue?vue&type=script&lang=js"
export * from "./ThemeSwitchView.vue?vue&type=script&lang=js"

import "./ThemeSwitchView.vue?vue&type=style&index=0&id=1cdc7153&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cdc7153"]])

export default __exports__